import { Badge } from '../../components/Shared/Badge';

export function getInvoiceStatusBadge(
  status?: string | null,
  t?: (key: string) => string,
) {
  const s = (status ?? '').toLowerCase();
  const label = t ? t(`invoices:status.${s}`) : status || '—';
  switch (s) {
    case 'draft':
      return <Badge variant="default">{label}</Badge>;
    case 'issued':
      return <Badge variant="info">{label}</Badge>;
    case 'sent':
      return <Badge variant="info">{label}</Badge>;
    case 'paid':
      return <Badge variant="success">{label}</Badge>;
    case 'cancelled':
      return <Badge variant="danger">{label}</Badge>;
    default:
      return <Badge variant="default">{label}</Badge>;
  }
}
